import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AdminMobileTopbar from "./AdminMobileTopbar";
import Button from "../../common/Button";
import success from "../../../assets/agent/success.svg";
import fail from "../../../assets/agent/fail.svg";
import { useNewUser } from "./useNewUser";

const MobileNewUser = () => {
  const { t } = useTranslation();
  const {
    form,
    errors,
    isSubmitting,
    successModal,
    errorModal,
    handleChange,
    handleSubmit,
    closeSuccessModal,
    setErrorModal,
  } = useNewUser();

  const roles = [
    { value: "Admin", label: t("admin.option.admin") },
    { value: "Agent", label: t("admin.option.agent") },
  ];
  const workshifts = [
    { value: "Morning", label: t("admin.option.morning") },
    { value: "Afternoon", label: t("admin.option.afternoon") },
    { value: "Fulltime", label: t("admin.option.fulltime") },
  ];

  const field = (label, name) => (
    <div className="mb-3">
      <label className="block text-white text-xs font-bold mb-1">{label} <span className="text-red-300">*</span></label>
      <input
        type="text"
        value={form[name]}
        onChange={(e) => handleChange(name, e.target.value)}
        className="w-full bg-white/10 text-white placeholder-white/50 text-sm rounded-lg px-3 py-2.5 border border-white/20"
      />
      {errors[name] && <p className="text-red-300 text-[10px] mt-1">{errors[name]}</p>}
    </div>
  );

  const selectField = (label, name, options) => (
    <div className="mb-3">
      <label className="block text-white text-xs font-bold mb-1">{label} <span className="text-red-300">*</span></label>
      <select
        value={form[name]}
        onChange={(e) => handleChange(name, e.target.value)}
        className="w-full bg-white/10 text-white text-sm rounded-lg px-3 py-2.5 border border-white/20"
      >
        <option value="" className="text-primary">{t("button.selectOption")}</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value} className="text-primary">{opt.label}</option>
        ))}
      </select>
      {errors[name] && <p className="text-red-300 text-[10px] mt-1">{errors[name]}</p>}
    </div>
  );

  return (
    <div
      className="flex flex-col h-screen overflow-y-auto"
      style={{ background: "linear-gradient(-80deg, #051D42 20%, #0C469F 82%, #0D4AA8 100%)" }}
    >
      <AdminMobileTopbar title={t("admin.newUser", "Nuevo usuario")} />

      <div className="flex-1 px-4 py-4">
        {field(t("admin.fullName", "Nombre completo"), "fullName")}
        {field(t("email"), "email")}
        {selectField(t("admin.role"), "role", roles)}
        {selectField(t("admin.workshift", "Turno"), "workshift", workshifts)}
        {field(t("admin.phone"), "phone")}

        <button
          type="button"
          onClick={handleSubmit}
          disabled={isSubmitting}
          className="w-full bg-secondary text-white text-sm font-extrabold rounded-xl py-3 mt-2 disabled:opacity-70"
        >
          {isSubmitting ? t("button.loading") : t("button.register")}
        </button>
      </div>

      {successModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
          <div className="bg-white rounded-2xl p-6 flex flex-col items-center text-center max-w-sm">
            <img src={success} alt="success" className="w-12 h-12 mb-3" />
            <p className="font-bold text-primary mb-2">{t("admin.userConfirm.head")}</p>
            <Link to="/dashboard">
              <Button variant="primary" onClick={closeSuccessModal}>{t("admin.userConfirm.btn")}</Button>
            </Link>
          </div>
        </div>
      )}
      {errorModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
          <div className="bg-white rounded-2xl p-6 flex flex-col items-center text-center max-w-sm">
            <img src={fail} alt="fail" className="w-12 h-12 mb-3" />
            <p className="font-bold text-primary mb-2">{t("admin.userError.head")}</p>
            {errors.submit && <p className="text-sm text-gray-500 mb-4">{errors.submit}</p>}
            <Button variant="secondary" onClick={() => setErrorModal(false)}>{t("admin.userError.btn")}</Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileNewUser;
